export const CoreInitiativesTasksName = 'CoreInitiativesTasks';
